import React from "react";

const ArrowIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.78166 5.33312L5.20566 1.75712L6.14833 0.814453L11.3337 5.99979L6.14833 11.1851L5.20566 10.2425L8.78166 6.66645H0.666992V5.33312H8.78166Z"
        fill="#5F83C2"
      />
    </svg>
  );
};

export default ArrowIcon;
